module.exports = __webpack_public_path__ + "img/cheque-on-delivery.fd0a98f8.png";